exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-container[data-v-97d0c01a] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.buttons[data-v-97d0c01a] {\n  display: flex;\n  justify-content: right;\n  text-align: right;\n  margin-top: 20px;\n}\n[data-v-97d0c01a] .el-dialog__title {\n  font-size: 22px;\n  color: #606266;\n}\n", ""]);

// exports
